import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import * as routes from '../../routes'
import { parseShippingsTrackingResponse } from '../../services/shippingsTracking/business'
import { useUserContext } from '../../auth/UserProvider'
import CTA from '../../ui/views/HomeMobile/CTA'
import ShippingsSummary from '../../ui/views/HomeMobile/ShippingsSummary'
import MultiLineSelect from '../../ui/components/MultiLineSelect'
import FiltersModal from '../../ui/views/HomeMobile/FiltersModal'

import { MOBILE_HOME_TABS } from '../../common/constants'
import { getServiceTypeOptions } from '../business'
import useShippingsTab from './useShippingsTab'
import { useShippingStates } from '../../services/shippingsTracking'

const DEFAULT_TAB_VALUE = MOBILE_HOME_TABS.SHIPMENTS

const HomeMobile = () => {
  const history = useHistory()
  const newAddedShippingCode = history.location?.state?.newShippingCode ?? null

  const {
    isLoading: isLoadingUserData,
    centres: userCenters,
    centerCode,
    centerHideId,
    setCenterCode,
    statusList,
  } = useUserContext()

  const handleChangeCenterCode = e => {
    setCenterCode(e.target.value)
    setTabValue(DEFAULT_TAB_VALUE)
  }

  const [tabValue, setTabValue] = useState(DEFAULT_TAB_VALUE)
  const tabShipments = useShippingsTab({
    type: MOBILE_HOME_TABS.SHIPMENTS,
    centerHideId,
    statusList,
  })

  const tabIncidents = useShippingsTab({
    type: MOBILE_HOME_TABS.INCIDENTS,
    centerHideId,
    statusList,
  })

  const shipments =
    tabShipments.data?.pages
      .map(page => page.data)
      ?.map(shipment => parseShippingsTrackingResponse(shipment, statusList))
      ?.map(shipment => shipment.shippings)
      ?.flat() ?? []

  const incidents =
    tabIncidents.data?.pages
      .map(page => page.data)
      ?.map(shipment => parseShippingsTrackingResponse(shipment, statusList))
      ?.map(shipment => shipment.shippings)
      ?.flat() ?? []

  const shippingCodes = shipments?.map(item => item.info.shippingCode) || []

  const incidentCodes = incidents?.map(item => item.info.shippingCode) || []

  const allCodes = shippingCodes.concat(incidentCodes)

  const { data: shippingsStates } =
    useShippingStates(allCodes)


  const tabData =
    tabValue === MOBILE_HOME_TABS.SHIPMENTS ? tabShipments : tabIncidents

  const [areFiltersOpen, setAreFiltersOpen] = useState(false)

  const handleClickFilters = e => {
    setAreFiltersOpen(true)
  }

  const handleCloseFilters = () => {
    setAreFiltersOpen(false)
  }

  const handleConfirmFilters = newFilters => {
    tabData.updateFilters(newFilters)
    handleCloseFilters()
  }

  const goToShippingSend = () => {
    history.push(routes.SHIPPING_SEND.linkTo())
  }

  useEffect(() => {
    const setDefaultFilters = () => {
      tabShipments.resetFilters()
      tabIncidents.resetFilters()
    }
    setDefaultFilters()
    //NOTE: do not add shipments & incidents to dependency arr or filters will not work
  }, [centerCode])

  const incidentsCount =
    tabIncidents?.data?.pages[0]?.data?.pagination?.record_count ?? null

  return (
    <>
      {centerCode && userCenters?.length > 1 ? (
        <MultiLineSelect
          isFullWidth
          options={userCenters}
          value={centerCode}
          onChange={handleChangeCenterCode}
        />
      ) : null}
      <ShippingsSummary
        isLoading={isLoadingUserData || tabData.isLoading}
        tabValue={tabValue}
        data={{
          shipments,
          incidents,
        }}
        states={shippingsStates}
        incidentsTotalResults={incidentsCount}
        appliedFiltersNumber={tabData.appliedFiltersNumber}
        onClickFilters={handleClickFilters}
        onTabChange={setTabValue}
        onResetFilters={tabData.resetFilters}
        incidentsVisorRef={tabIncidents.visorRef}
        shipmentsVisorRef={tabShipments.visorRef}
      />
      <FiltersModal
        isOpen={areFiltersOpen}
        onClose={handleCloseFilters}
        type={tabValue}
        initialFilters={tabData.filters}
        statusOptions={statusList}
        serviceTypeOptions={getServiceTypeOptions(userCenters, centerCode)}
        onConfirm={handleConfirmFilters}
      />
      <CTA
        isFirstVisit={
          !tabData.isLoading &&
          !Boolean(tabShipments?.data?.shippings?.length !== 0)
        }
        onVisitShippingSend={goToShippingSend}
        newAddedShippingCode={newAddedShippingCode}
      />
    </>
  )
}

export default HomeMobile
